import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { useChatStore } from '../model/chatStore';

const SHOWN = 8;

/** The latest chats, in the sidebar. Chats are kept in this browser. */
export function RecentChats({ onPick }: { onPick?: (() => void) | undefined }) {
  const conversations = useChatStore((s) => s.conversations);
  const activeId = useChatStore((s) => s.activeId);
  const select = useChatStore((s) => s.select);
  const navigate = useNavigate();
  const onHome = useLocation().pathname === '/';
  if (conversations.length === 0) return null;

  return (
    <Stack component="section" aria-label="Recent chats" sx={{ px: 1.25, pb: 2 }}>
      <Typography variant="caption" component="h2" sx={{ display: 'block', px: 1.25, pb: 0.75, color: 'text.secondary', letterSpacing: '0.01em' }}>
        Recent chats
      </Typography>
      <Stack component="ul" sx={{ listStyle: 'none', m: 0, p: 0, gap: 0.25 }}>
        {conversations.slice(0, SHOWN).map((c) => {
          const isActive = onHome && c.id === activeId;
          return (
            <li key={c.id}>
              <ButtonBase
                aria-current={isActive ? 'true' : undefined}
                onClick={() => { select(c.id); void navigate('/'); onPick?.(); }}
                sx={{ ...itemSx, bgcolor: isActive ? 'surface.sunken' : 'transparent' }}
              >
                <Typography variant="body2" noWrap sx={{ fontSize: '0.8125rem', color: isActive ? 'text.primary' : 'text.secondary' }}>
                  {c.title}
                </Typography>
              </ButtonBase>
            </li>
          );
        })}
      </Stack>
    </Stack>
  );
}

const itemSx = {
  width: '100%',
  justifyContent: 'flex-start',
  minHeight: 34,
  px: 1.25,
  borderRadius: 1,
  transition: 'background-color 120ms',
  '&:hover': { bgcolor: 'surface.subtle', '& p': { color: 'text.primary' } },
} as const;
